import { fetchAaguidCatalog } from '@newcore/ui/passkey';
import { useQuery } from '@tanstack/react-query';
import { getCdnBaseUrl } from '@/config/env-config';

export function useAaguidCatalog() {
  return useQuery({
    queryKey: ['fido-catalog'],
    queryFn: () => fetchAaguidCatalog(getCdnBaseUrl()),
    staleTime: Infinity,
  });
}
